import { makePieActionObjs } from "shared/imports/pieActionGenerators"

const loadOrganizationObjs = makePieActionObjs("load", "Organization")
export const loadOrganizationActionDict = loadOrganizationObjs.pieDict

const deleteOrganizationObjs = makePieActionObjs("delete", "Organization")
export const deleteOrganizationActionDict = deleteOrganizationObjs.pieDict

// Edit Form
const postOrganizationFormObjs = makePieActionObjs("post", "Organization")
export const postOrganizationFormActionDict = postOrganizationFormObjs.pieDict

const patchOrganizationFormObjs = makePieActionObjs("patch", "Organization")
export const patchOrganizationFormActionDict = patchOrganizationFormObjs.pieDict

const patchDataDescriptionObjs = makePieActionObjs("patch", "data_description")
export const patchDataDescriptionActionDict = patchDataDescriptionObjs.pieDict

const postDataDescriptionObjs = makePieActionObjs("post", "data_description")
export const postDataDescriptionActionDict = postDataDescriptionObjs.pieDict

const loadOrganizationTransactionSummaryObjs = makePieActionObjs("load", "transaction_summary")
export const loadOrganizationTransactionSummaryActionDict = loadOrganizationTransactionSummaryObjs.pieDict

const OrganizationActionTypes = {
    ...loadOrganizationObjs.actionTypes,
    ...deleteOrganizationObjs.actionTypes,
    ...postOrganizationFormObjs.actionTypes,
    ...patchOrganizationFormObjs.actionTypes,
    ...loadOrganizationTransactionSummaryObjs.actionTypes,
    INVALIDATE_ORGANIZATION: "ORGANIZATION_PROFILE_INVALIDATE_ORGANIZATION",
}

export default OrganizationActionTypes
